import { CreateParams } from '..'
import { Element, Group } from 'zrender'
import { createImage, createText } from '../helpers'

/**
 * Create a comparison tile.
 */
export function comparison({
    width,
    tile
}: CreateParams<Tile & { type: 'comparison' }>) {
    const items = tile.items
    const padding = width * 0.01
    const maxWidth = width / items.length - padding
    const elements: Element[] = []

    for (let i = 0; i < items.length; i++) {
        const item = items[i]

        let y = 0
        let x = (maxWidth + padding) * i
        let maxTextWidth = maxWidth

        const group = new Group({
            y: 0,
            x
        })

        if (item.icon) {
            const img = createImage(item.icon)
            x = img.getWidth() + 10
            maxTextWidth -= img.getWidth() + 10
            const width = img.getWidth()
            const height = img.getHeight()
            img.setStyle({ width, height })
            group.add(img)
        }

        if (item.title) {
            const text = createText(item.title, 'lg', maxTextWidth)
            text.y = y
            text.x = x
            group.add(text)
            y += text.getBoundingRect().height + 5
        }

        if (item.subtitle) {
            const text = createText(item.subtitle, 'md', maxTextWidth)
            text.y = y
            text.x = x
            group.add(text)
            y = group.getBoundingRect().height + 10
        }

        if (item.text) {
            const text = createText(item.text, 'xl', maxTextWidth)
            text.y = y
            text.x = maxWidth / 2 - text.getBoundingRect().width / 2
            group.add(text)
            y = group.getBoundingRect().height
        }

        if (item.subtext) {
            const text = createText(item.subtext, 'md', maxTextWidth)
            text.y = y
            text.x = maxWidth / 2 - text.getBoundingRect().width / 2
            group.add(text)
        }

        elements.push(group)
    }

    return elements
}
